import type { CompaniesIndustry } from '@xing-com/crate-common-graphql-types';

import type { IndustryItem } from '../types';

export const createCompanyIndustry = (
  item: CompaniesIndustry
): IndustryItem => ({
  id: item?.industry?.id || '',
  key: item?.industry?.localizationKey || '',
  title: item?.industry?.localizationValue || '',
  totalCompanies: item?.total || 0,
});

export const createCompaniesIndustries = (
  items: CompaniesIndustry[]
): IndustryItem[] => items.map(createCompanyIndustry);
